import React, { useEffect, useLayoutEffect, useState } from "react";

import { StepContainer, NavigationButtons, InfoBox } from "../index";

import { useWizard } from "../../wizard";

import { contentApi } from "../../services/contentApi";

import { contentKeys } from "../../constants/contentKeys";

const ConsentConfirmationStep: React.FC = () => {
  const { selfServiceData, sessionId, updateSelfServiceData } = useWizard();

  const [title, setTitle] = useState<string>("Samtykke registreret");

  const [body, setBody] = useState<string>("Tak. Dit samtykke er registreret.");

  useEffect(() => {
    contentApi
      .getByKey(contentKeys.pas_samtykke.consent_confirmation)
      .then((c) => {
        if (c?.title) {
          setTitle(c.title);
        }

        if (c?.body && c.body.length > 0) {
          setBody(c.body[0]);
        }
      });
  }, []);

  useLayoutEffect(() => {
    updateSelfServiceData("isCompleted", true);
  }, [updateSelfServiceData]);

  const { consentChildName, consentChildCpr, consentCustodyType } =
    selfServiceData;

  return (
    <StepContainer title={title}>
      <InfoBox type="success">
        <p>{body}</p>
      </InfoBox>

      {(consentChildName || consentChildCpr || consentCustodyType) && (
        <>
          <h3>Samtykke detaljer</h3>

          <ul className="summary-list">
            {consentChildName && (
              <li>
                <span className="label">Barn</span>

                <span className="value">{consentChildName}</span>
              </li>
            )}

            {consentChildCpr && (
              <li>
                <span className="label">CPR-nummer</span>

                <span className="value">{consentChildCpr}</span>
              </li>
            )}

            {consentCustodyType && (
              <li>
                <span className="label">Forældremyndighed</span>

                <span className="value">
                  {consentCustodyType === "ene" && "Eneforældremyndighed"}

                  {consentCustodyType === "med" && "Fælles forældremyndighed"}

                  {consentCustodyType === "vaerge" && "Værge"}

                  {consentCustodyType === "anden" && "Anden"}
                </span>
              </li>
            )}
          </ul>
        </>
      )}

      <p style={{ marginTop: "2rem", fontSize: "0.85rem", color: "#d0d0d0" }}>
        <span style={{ opacity: 0.5 }}>
          <strong>Reference:</strong> {sessionId?.slice(-5) || ""}
        </span>
      </p>

      <NavigationButtons showBack={false} showNext={false} />
    </StepContainer>
  );
};

export default ConsentConfirmationStep;
